import { digitsEnToFa } from 'persian-tools2';
import { useMutation } from '@tanstack/react-query';

import { loginApi, sendLoginCode, signup } from 'api/registerAgent';
import { registerSteps } from 'components/Login/SignIn';
import { usePatientsContext } from 'context/patient_context';
import { usersUrls } from 'helpers/Urls';
import axiosInstance from 'utils/axiosInstance';
import { useAuthContext } from '../context/auth/AuthContext';

const handleTokenFireBase = async (event) => {
  if ( event && typeof event.data === 'string') {
    const TokenData = JSON?.parse(event?.data);
    const Data = {
      token: TokenData?.tokenFireBase ,
      clientApplication:TokenData?.clientApplication ,
      deviceType:TokenData?.deviceType
    };
    if (localStorage.getItem('token')) {
      localStorage.setItem('fireBaseToken', TokenData?.tokenFireBase);
      const res = await axiosInstance.post(usersUrls.notificationToken, Data);
    }
  }
  document.removeEventListener('message', handleTokenFireBase);
  window.removeEventListener('message', handleTokenFireBase);
};

const getTokenFireBase = () => {
  window?.ReactNativeWebView?.postMessage('tokenFireBase');
  document.addEventListener('message', handleTokenFireBase);
  window.addEventListener('message', handleTokenFireBase);
};

const useSendLoginCode = () => {
  const { handleOpenSnackbar } = usePatientsContext();
  return useMutation({
    mutationFn: sendLoginCode,
    retry: false,
    onSuccess: (res, args) => {
      const {
        setSteps,
        startTimer,
        resetTimer,
        transition,
        setShowTransition,
        userPhone,
        phone,
        setUserPhone,
      } = args || {};

      if (res.status === 200) {
        const status = res.data.status;
        const uniqPhoneNumbers = userPhone?.filter((item) => item.phone !== phone);

        if (status === 0 && res.data.activationCodeId) {
          resetTimer();
          startTimer();
          setSteps(registerSteps.login);
          if (transition) {
            setShowTransition((prev) => !prev);
          }
          setUserPhone([...uniqPhoneNumbers,
          {
            futurTimeExp: Date.now() + res.data.activationCodeRemainingSeconds * 1000,
            activationCodeId: res.data.activationCodeId,
            activationCodeRemainingSeconds: res.data.activationCodeRemainingSeconds,
            phone,
          }]);
        } else {
          const snackbarText =
            status === 2
              ? `کد ارسال شده تا ${digitsEnToFa(
                res.data.activationCodeRemainingSeconds.toString()
              )} ثانیه دیگر فعال است`
              : '';
          handleOpenSnackbar(snackbarText, 'error');
        }
      }
    },
    onError: (error) => {
      handleOpenSnackbar('خطای ارتباط با سرور، لطفا مجدد امتحان کنید', 'error');
    },
  });
};

const useLoginAgent = () => {
  const { handleOpenSnackbar } = usePatientsContext();
  const { login } = useAuthContext();
  return useMutation({
    mutationFn: loginApi,
    onSuccess: (res, args) => {
      const { setSteps, setShowTransition, navigateToDashboard, resetTimer, isScanCenter } =
        args || {};

      if (res?.status === 200) {
        login(res.data.token.accessToken, res.data.token.refreshToken);
        getTokenFireBase();

        const registeredAsAgent = !res.data?.user?.roles?.includes('agent') || res.data?.user?.isScanCenter;
        const registeredAsScanCenter = !res.data?.user?.isScanCenter;

        const registerRole = isScanCenter ? registeredAsScanCenter : registeredAsAgent;

        if (registerRole) {
          setSteps(registerSteps.signup);
          setShowTransition('login');
        } else {
          resetTimer();
          localStorage.setItem('registered', true);
          window?.ReactNativeWebView?.postMessage('login');
          navigateToDashboard();
          setShowTransition(false);
        }
      }
    },
    onError: (error) => {
      handleOpenSnackbar(error.response.data.messages, 'error');
    },
  });
};

const useSignupAgent = () => {
  const { handleOpenSnackbar } = usePatientsContext();
  const { login } = useAuthContext();
  return useMutation({
    mutationFn: signup,
    onSuccess: (res, args) => {
      const { navigateToDashboard, setSteps } = args || {};
      if (res.status === 200) {
        localStorage.setItem('registered', true);
        window?.ReactNativeWebView?.postMessage('login');
        login(res.data.token.accessToken, res.data.token.refreshToken);
        navigateToDashboard();
        setSteps(registerSteps.sendloginCode);
      }
    },
    onError: (error) => {
      handleOpenSnackbar(error.response.data.messages, 'error');
    },
  });
};

export { useSendLoginCode, useLoginAgent, useSignupAgent };


